import React from 'react';

import Input from '../Input';
import useRadioOptions from './useRadioOptions';

function RadioInput({id, label, question, values, onChange, invalid}) {
  const options = useRadioOptions(question, values);

  return (
    <Input
      id={id ? id : `answer-${question.id}`}
      label={label}
      type="select"
      value={values.length > 0 ? values[0] : ''} 
      onChange={e => onChange([e.target.value], e.target.value !== '')} 
      invalid={invalid}>
      {values.length === 0 && <option value="">Choose an option...</option>}
      {options.map(option => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Input>
  );
}

export default RadioInput;
